import ImportantDocumentsBlock from './ImportantDocumentsBlock';
export {
  POLICY_AGREEMENT_PDF,
  PRE_SALE_INFO_PDF,
  PRODUCT_FACT_PDF
} from './constants';
export { ImportantDocumentsBlock };
